export default "__VITE_ASSET__B2zQAi9b__"